
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage} from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyBYG9mnQAvM-TcWcWph-6ORCu6tACGJcSQ",
  authDomain: "saveit-f5526.firebaseapp.com",
  projectId: "saveit-f5526",
  storageBucket: "saveit-f5526.appspot.com",
  messagingSenderId: "456736692241",
  appId: "1:456736692241:web:8e686b7479f8c82f2939b0"
};

export const app = initializeApp(firebaseConfig);
export const database = getFirestore(app);
export const storage = getStorage(app);